import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase'

const SettingsMyProfile = ({
  color = 'icon.primary',
  fill = 'transparent',
  strokeWidth = '1.3',
  ...props
}) => (
  <IconBase viewBox='0 0 20 20' {...props}>
    <Path
      d='M3.99219 16.5805C5.56137 15.0553 7.68462 14.1172
         10.0159 14.1172C12.3242 14.1172 14.4244 15.0363
         15.9936 16.5335C14.4244 18.0586 12.3012 18.9968
         9.96989 18.9968C7.66162 18.9968 5.56137 18.0777
         3.99219 16.5805Z'
      fill-rule='evenodd'
      clip-rule='evenodd'
      stroke={color}
      fill={fill}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M1.97511 14.0265C1.36504 12.8124 1 11.4532
         1 10.0011C1 5.02647 5.02647 1 10.0011 1C14.9756
         1 19.0021 5.02647 19.0021 10.0011C19.0021
         11.4512 18.6391 12.8114 18.025 14.0245'
      stroke={color}
      fill={fill}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M12.1219 5.88659C13.2936 7.0583 13.2936 8.95802
         12.1219 10.1297C10.9502 11.3014 9.05049 11.3014
         7.87878 10.1297C6.70707 8.95802 6.70707 7.0583
         7.87878 5.88659C9.05049 4.71489 10.9502 4.71489
         12.1219 5.88659'
      stroke={color}
      fill={fill}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </IconBase>
)

SettingsMyProfile.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default SettingsMyProfile
